import { useContext } from "react";
import { dataContext } from "../utils/constants";

export default function Header({ toggleSidebar }) {
    const context = useContext(dataContext);
    const username = context.user.username;

    return (
        <nav className="navbar">
            <div className="nav--container">
                <div className="nav--logo--img"></div>
                <div className="nav--text">{username}</div>
                <button
                    className="navbar-toggler border-0 p-0"
                    onClick={toggleSidebar}
                    style={{
                        height: "40px",
                        width: "40px",
                    }}
                >
                    <i className="bi bi-list" style={{ fontSize: "2rem" }}></i>
                </button>
            </div>
        </nav>
    );
}
